define('gameday-index-gdaudio/subcomponents/AudioFeedDisplayUnit',['require','exports','module','jquery','./FeedFetcher','requirejs-hogan-plugin/hogan','gameday-index-configurator/GamedayIndexConfigurator','text!../tpl/gd_audioFeeds.tpl','gameday-index-enums/enums/events/DisplayEvents','app-console/app-console','tether/tether','message-service/message-service','extant/extant'],function(require, exports, module) {
	var $ = require("jquery"),
		Feeds = require("./FeedFetcher"),
		hogan = require('requirejs-hogan-plugin/hogan'),
		SiteConfig = require("gameday-index-configurator/GamedayIndexConfigurator"),
		feedTemplate = hogan.compile(require('text!../tpl/gd_audioFeeds.tpl')),
		DisplayEvts = require("gameday-index-enums/enums/events/DisplayEvents"),
		logg = require("app-console/app-console"),
		Tether = require("tether/tether"),
		MessageService = require("message-service/message-service"),
		exists = require("extant/extant");

	var targetDiv,
		displayDiv,
		tpl = "",
		mediaStatus,
		mediaStatusMessage = {
		   "MEDIA_OFF" : "Audio available when game begins",
		   "MEDIA_DONE" : "Archive audio available soon",
		   "DEFAULT_TEXT" : "No Feeds Available"
		};
		

	function AudioFeedDisplayUnit(myHome, gidVO, feedList) {
		targetDiv = myHome;

		if (!exists(feedList)) {
			logg.log("load feeds before display");
			var feeds = new Feeds();
			feeds.loadGrid(gidVO);
		} else {
			logg.log("feeds provided. let's do this");
			this.display(feedList);
		}
	}

	AudioFeedDisplayUnit.prototype = {

		display: function(feeds, xpos) {

			displayDiv = document.createElement("div");
			displayDiv.className = "audioFeedList";
			$(displayDiv).appendTo($("body"));
            mediaStatus = feeds.combinedMediaState;
            
            if (mediaStatus === 'MEDIA_OFF' || mediaStatus === 'MEDIA_DONE') {
               feeds = {};
               feeds.directive = mediaStatusMessage[mediaStatus];
            } else {              
               feeds.directive = (exists(feeds.home_audio) || exists(feeds.alt_home_audio) || exists(feeds.away_audio) || exists(feeds.alt_away_audio)) ? "" : mediaStatusMessage['DEFAULT_TEXT'];
            }
            
            
			feeds.loginState = SiteConfig.getLoginStatus();
            feeds.ssl        = SiteConfig.getSecureDomain();
           
            feeds.homeTeamClass  = (exists(feeds.home_audio)) ? feeds.home_audio.teamCode.toLowerCase() : "";
            feeds.awayTeamClass  = (exists(feeds.away_audio)) ? feeds.away_audio.teamCode.toLowerCase() : "";
            
			$(displayDiv).html(feedTemplate.render(feeds));
			var divpos = $("#GDAudio").offset();
			MessageService.one("gdidx::writePlayerToPage", function() {
			  $("#GDHeaderContent").addClass("audiopicked");
			});
			
			// $(displayDiv).css("left", xpos);

			new Tether({
				element: displayDiv,
				target: targetDiv,
				attachment: 'top middle',
				targetAttachment: 'bottom middle',
				offset: '7 0',
				constraints: [
					{
						to: [],
						attachment: 'together',
						pin: true
					}
				]
			});

			$("#audioFeeds").on("click", ".channel", function() {
				var stationName = (exists(this.innerText)) ? this.innerText : this.textContent;

				MessageService.publish(DisplayEvts.audioFeedSelected, { contentID: this.id, station: stationName });
				MessageService.publish("gdidx::destroyFeedList");
								
			});

			setTimeout(function() {
				$("body").on("mousemove", function(e) {
					var parentTarget = e.target.parentElement,
					    inTheZone = (e.target.id !== "" && e.target.id !== "GDAudio" && parentTarget.id !== "audioFeeds" && (!$(parentTarget).hasClass("channel")) && parentTarget.id !== "logoutButton");
					
					if (inTheZone) {
					   MessageService.publish("gdidx::destroyFeedList");						
					}
				});
			}, 1000);
		},

		destroy: function() {
			$(displayDiv).remove();
		}
	};

	return AudioFeedDisplayUnit;
});
